var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-loader-overlay",class:{ show: _vm.overlay, absolute: _vm.absolute },style:(_vm.getOverlayStyles)},[_c('div',{staticClass:"custom-loader",style:(_vm.getStyles)})])
}
var staticRenderFns = []

export { render, staticRenderFns }